import { useState, useEffect, FormEvent, ReactNode } from 'react'
import { Button, Form, Dropdown } from 'react-bootstrap';
import SettingsHeader from './console/SettingsHeader';
import { APIRequestGet, APIRequestPost } from '../utils/APIRequests';
import {
    FirmwareDataList,
    FirmwareListSchema,
    FirmwaresAddFirmwareRequestData,
    FirmwaresDeleteRequestData,
    FirmwaresSetReleaseRequestData
} from '../api/Firmwares';
import FirmwareInfoTableV2 from './FirmwareInfoTableV2';

function FirmwareV2(): ReactNode {
    const [loading, setLoading] = useState<boolean>(true);
    const [firmwareList, setFirmwareList] = useState<FirmwareDataList>([]);
    const [firmwareText] = useState<string>("");
    const [currentVersion, setVersion] = useState<string>("Version");
    const [currentFirmwareVersion, setFirmwareVersion] = useState<string>("Firmware version");
    const [firmwareUrl, setFirmwareUrl] = useState<string>("Firmware url");

    useEffect(() => {
        console.log("firmware mount");
        updateFirmwares()
    }, []);

    function updateFirmwares(): void {
        APIRequestGet(`/firmwares/getall`, {
            schema: FirmwareListSchema,
            logSuccess: true
        }).then(response => {
            setLoading(false);
            setFirmwareList(response.data);
        });
    }

    function setRelease(isRelease: boolean, id: string): void {
        setLoading(true);

        const data: FirmwaresSetReleaseRequestData = { isRelease, id };

        APIRequestPost(`/firmwares/setRelease`, {
            data: data
        }).then(() => {
            updateFirmwares();
        });
    }

    function del(id: string): void {
        setLoading(true);

        const data: FirmwaresDeleteRequestData = { id };

        APIRequestPost(`/firmwares/delete`, {
            data: data
        }).then(() => {
            updateFirmwares();
        });
    }

    function onSubmitFile(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        console.log(firmwareUrl);
        console.log(currentFirmwareVersion);
        console.log(currentVersion);

        const data: FirmwaresAddFirmwareRequestData = {
            firmwareUrl: firmwareUrl,
            firmwareVersion: currentFirmwareVersion,
            deviceVersion: currentVersion
        };

        APIRequestPost(`/firmwares/addFirmware`, {
            logSuccess: true,
            data: data
        }).then(() => {
            updateFirmwares();
        });
    }

    const onChangeFirmwareVersion = (event: React.ChangeEvent<HTMLInputElement>): void => {
        event.preventDefault();
        setFirmwareVersion(event.target.value);
    };

    const onChangeFirmwareUrl = (event: React.ChangeEvent<HTMLInputElement>): void => {
        event.preventDefault();
        setFirmwareUrl(event.target.value);
    };

    return (<>
        <SettingsHeader />
        <div className='max-width text-page-padding'>
            <h1>Firmware</h1>
            <Form onSubmit={onSubmitFile}>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Firmware version</Form.Label>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" style={{ width: "100%" }}>
                            {currentVersion}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setVersion('2002')}>2002</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Firmware version"
                        value={currentFirmwareVersion}
                        onChange={onChangeFirmwareVersion}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Url"
                        value={firmwareUrl} onChange={onChangeFirmwareUrl}
                    />
                </Form.Group>

                <Button variant="primary" type="submit">Load</Button>
            </Form>
            <h2>{firmwareText}</h2>
            {loading ? (
                <p><em>Loading...</em></p>
            ) : (
                <FirmwareInfoTableV2
                    firmwareList={firmwareList}
                    setRelease={setRelease}
                    deleteEntry={del}
                />
            )}
        </div>
    </>)
}

export default FirmwareV2;